import React from "react";
import { useState } from "react";
import "./OffersPage.css";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";

const OfferCard = ({ offer, isExpanded, onExpand }) => {
  const [params] = useSearchParams();
  const [showDefaultOfferPopup, setShowDefaultOfferPopup] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const utmMedium = params.get("utm_medium") || "";
  
  const proceedWithOffer = async () => {
    setUserClickData({
      event_name: `offer-apply-button-offer-check-v1-consent-${offer.lender_name}`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || "",
      utm_medium: utmMedium || "No Medium Found",
    });
    setUserClickData({
      event_name: `offer-apply-button-prefr-v1-lead`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || "",
      utm_medium: utmMedium || "No Medium Found",
    });

    window.location.href = `${offer.app_url}`;
  };

  const handleClick = () => {
    if (isProtium) {
      setShowDefaultOfferPopup(true);
    } else {
      setUserClickData({
        event_name: `offer-apply-button-prefr-v1-lead-${offer.lender_name}`,
        user_id: offer.lead_id || "No User ID found",
        affiliate_id: params.get("aff_id") || "No Aff_id found",
        utm_source: params.get("utm_source") || "",
        utm_medium: utmMedium || "No Medium Found",
      });
      setUserClickData({
        event_name: `offer-apply-button-prefr-v1-lead`,
        user_id: offer.lead_id || "No User ID found",
        affiliate_id: params.get("aff_id") || "No Aff_id found",
        utm_source: params.get("utm_source") || "",
        utm_medium: utmMedium || "No Medium Found",
      });

      window.location.href = `${offer.app_url}`;
    }
  };

  const isLNT = offer.lender_id === "662752eb65fdba1a48d6e482";
  const isProtium = offer.lender_id === "662752eb65fdba1a48d6e47c";
  const horizontalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_hl || offer.logo_image_url;

  const verticalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_vl || offer.logo_image_url;

  const getLoanLabel = () => {
    if (["69a2c7ab1f6f4ddfd5577314", "69ea0b864084a68bdadc40bd", "6abb59d6a3ee46254d954755"].includes(offer.lender_id))
      return "Gold Loan Amount:";
    if (offer.lender_id === "69a1d3801f6f4ddfd55732ed")
      return "Credit Line Amount:";
    if ([
      "662752eb65fdba1a48d6e466","666ec1953a9a969d8f9980f1","67762d497ae263a3ec86347e",
      "6799b8fada60414f0f195bf9","67bd3abe694463207380f33d","67be8fc6049b9a4e3af8191a",
      "67e23d6fe162ba8f717ec5bf","67ef646df80610d286084e60","68401febe871a7a9504dc2e3",
      "699d44721f6f4ddfd556e5cd","6954d268fb8b8c1ebb0d1937","68b7cb3721c19b150d2893da",
      "662752eb65fdba1a48d6e47c","69dd0df04d3185176dd02d27",
    ].includes(offer.lender_id))
      return "Max Loan Amount:";
    return "Pre-Approved Amount:";
  };

  return (
    <>
      {showDefaultOfferPopup && isProtium && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg max-h-[90vh] flex flex-col">
            <h2 className="text-xl font-semibold mb-4">
              Do you want to proceed with Protium for a personal loan?
            </h2>
            <div
              className="overflow-y-auto pr-2 mb-4 text-sm text-gray-700"
              style={{ maxHeight: "50vh" }}
            >
              <div className="mb-4">
                <p className="mb-2">
                  You are deemed to have full and adequate authority/legal
                  competency to submit the application and relevant documents
                  for availing the loan from Protium Finance Limited ("Protium").
                </p>
                <p className="mb-2">
                  You authorize Protium or its agents/representatives to use the
                  documents and personal information provided by you to conduct
                  credit reference checks by extracting additional information
                  from various third-party sources (including but not limited
                  to) like credit bureaus, government agencies, banks, CERSAI
                  etc. You authorize Protium to use the same information to
                  conduct further checks for any additional loans in the future
                  and ongoing review. You also authorize Protium to share the
                  application details to other regulated entities or co-lenders
                  at its own discretion.
                </p>
                <p className="mb-2">
                  You authorize Protium for communication with you on any mode
                  (telephone calls/SMS/messaging services like WhatsApp, emails
                  etc.) with respect to revisions in terms & conditions and/or
                  new services/offers from Lender. Further, any acceptance by
                  you from the mobile number(s) and Email ID(s) provided by you
                  will be binding in nature.
                </p>
                <p className="mb-2">
                  You confirm that laws concerning the unsolicited communication
                  referred in "National Do Not Call Registry" (the "NDNC
                  Registry") will not be applicable for such communication
                  received from Protium and/or associates.
                </p>
                <div className="flex items-start mt-4">
                  <input
                    type="checkbox"
                    id="authorizeCheckbox"
                    className="mt-1 mr-2"
                    checked={isAuthorized}
                    onChange={(e) => setIsAuthorized(e.target.checked)}
                  />
                  <label htmlFor="authorizeCheckbox" className="text-gray-700">
                    You confirm to have read and accepted the declaration
                    mentioned at{" "}
                    <a
                      href="https://us-west-2.protection.sophos.com/?d=protium.co.in&u=aHR0cHM6Ly9wcm90aXVtLmNvLmluL3JlZ3VsYXRvcnkvcHJpdmFjeS1wb2xpY3kv&i=NjMwYzkyM2IxNDNlYTYxMjQ3MjQ5YjVm&t=L1BWRi96ek1rMVFlWGkyWjdoVEY1VnpGZnpCWnBmQ3M0MmFEOFdtWXN4OD0=&h=a9ca60c125764c23a95aa51ecc9a1ab3&s=AVNPUEhUT0NFTkNSWVBUSVY5bFm-Ar0_hxsX92H2BJj_Rd6MYRHu-nNvMqLEFWzsJA"
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://us-west-2.protection.sophos.com/?d=protium.co.in&u=aHR0cHM6Ly9wcm90aXVtLmNvLmluL3JlZ3VsYXRvcnkvdGVybXMtYW5kLWNvbmRpdGlvbnMv&i=NjMwYzkyM2IxNDNlYTYxMjQ3MjQ5YjVm&t=UVIra0R0NnNIOG9TUldIUkk4Z0ZBVnB5NEtoUHpnSERWVzZHQmJGekNRZz0=&h=a9ca60c125764c23a95aa51ecc9a1ab3&s=AVNPUEhUT0NFTkNSWVBUSVY5bFm-Ar0_hxsX92H2BJj_Rd6MYRHu-nNvMqLEFWzsJA"
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      T&amp;C
                    </a>
                    .
                  </label>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-auto">
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setShowDefaultOfferPopup(false)}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 rounded text-white ${
                  isAuthorized ? "bg-blue-600" : "bg-blue-300 cursor-not-allowed"
                }`}
                disabled={!isAuthorized}
                onClick={() => {
                  setShowDefaultOfferPopup(false);
                  proceedWithOffer();
                }}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="offer-card-section1">
        <div
          className={`offer-card1 ${isExpanded ? "expanded1-pf" : "collapsed1"}`}
          onClick={onExpand}
        >
          {/* ── Logo ── */}
          {isExpanded && (
            <div className="prefr-logo-wrapper">
              <img src={horizontalLogo} className="lender-logo-pf" alt="Lender" />
            </div>
          )}

          <div className="offer-details">
            {isExpanded && <hr className="offer-divider-pf" />}

            {isExpanded ? (
              <div className="offer-row-pf">
                <span className="offer-label-pf">{getLoanLabel()}</span>
                <span className="offer-value-pf">upto ₹{offer.credit_limit}</span>
              </div>
            ) : (
              <div className="amount-row">
                <img src={verticalLogo} className="lender-logo" alt="Lender" />
                <div>
                  <span className="amount-label1">{getLoanLabel()}</span>
                  <br />
                  <span className="amount-value1"> upto ₹{offer.credit_limit}</span>
                </div>
              </div>
            )}

            {isExpanded && <hr className="offer-divider" />}

            {isExpanded && (
              <>
                {offer.lender_id === "69a2c7ab1f6f4ddfd5577314" ? (
                  <div className="emi-row">
                    Your details have been shared with the IIFL. Someone from IIFL team will
                    contact you within the next 24–48 hours.
                  </div>
                ) : offer.lender_id === "69ea0b864084a68bdadc40bd" ? (
                  <div className="emi-row">
                    Your details have been shared with the Muthoot Finance. Someone from Muthoot team will
                    contact you within the next 24–48 hours.
                  </div>
                ) : (
                  <div className="offer-row-pf">
                    <span className="offer-label-pf">Tenure:</span>
                    <span className="offer-value-pf">{offer.tenure || 48} Months</span>
                  </div>
                )}

                <hr className="offer-divider" />

                {offer.interest_rate && (
                  <>
                    <div className="offer-row-pf">
                      <span className="offer-label-pf">Interest Rate:</span>
                      <span className="offer-value-pf">{offer.interest_rate}</span>
                    </div>
                    <hr className="offer-divider" />
                  </>
                )}

                {offer.processing_fee && (
                  <>
                    <div className="offer-row-pf">
                      <span className="offer-label-pf">Processing Fees:</span>
                      <span className="offer-value-pf">{offer.processing_fee}</span>
                    </div>
                    <hr className="offer-divider" />
                  </>
                )}

                <div className="loan-extra-details mt-3 text-sm text-gray-700">
                  {offer.apr && (
                    <div className="offer-row-pf">
                      <span className="offer-label-pf">APR:</span>
                      <span className="offer-value-pf">{offer.apr}</span>
                    </div>
                  )}
                  {offer.penal_charges && (
                    <div className="offer-row-pf">
                      <span className="offer-label-pf">Penal Charges:</span>
                      <span className="offer-value-pf">{offer.penal_charges}</span>
                    </div>
                  )}
                  {offer.kfs_doc && (
                    <div className="offer-row-pf">
                      <span className="offer-label-pf">View KFS:</span>
                      <a
                        href={offer.kfs_doc}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center text-green-700 font-semibold hover:underline"
                      >
                        <FileText className="w-4 h-4 mr-1" />
                        Document
                      </a>
                    </div>
                  )}
                </div>

                <button
                  className="get-offer-btn-pf tracking-get-offer-btn-v5"
                  id={`btn-get-offer-v5`}
                  onClick={handleClick}
                >
                  Claim Offer{" "}
                  <img
                    src="/assets/img/Get offer CTA icon.svg"
                    alt="Arrow"
                    className="cta-icon"
                  />
                </button>
              </>
            )}
          </div>

          {!isExpanded && (
            <img
              src="/assets/img/arrowOffer.png"
              className="collapse-arrow1"
              alt="Expand"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default OfferCard;